import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { STEPS } from "@/content/site";
import { Reveal, MaskLine } from "./Reveal";
import { SectionHead } from "./Bits";

export default function Process() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });

  return (
    <section id="proceso" data-testid="process-section" className="grain relative bg-[#1E2228] py-24 text-white sm:py-32">
      <div className="container-x grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal><SectionHead index="04" eyebrow="Proceso de trabajo" dark /></Reveal>
            <h2 className="mt-6 font-display text-3xl font-light uppercase leading-[1.08] sm:text-5xl">
              <MaskLine inView>De la idea</MaskLine>
              <MaskLine inView delay={0.1}>a la <span className="font-serif-it normal-case text-[#C9A66B]">entrega de llaves</span></MaskLine>
            </h2>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-md text-base leading-relaxed text-white/80">
                Un método claro, con un interlocutor y decisiones informadas en cada etapa.
              </p>
            </Reveal>
          </div>
        </div>
        <div ref={ref} className="relative lg:col-span-7">
          <div className="absolute left-[15px] top-2 h-[calc(100%-1rem)] w-px bg-white/15 sm:left-[23px]" />
          <motion.div style={{ scaleY: scrollYProgress }} className="absolute left-[15px] top-2 h-[calc(100%-1rem)] w-px origin-top bg-[#C9A66B] sm:left-[23px]" />
          <ol className="space-y-12 sm:space-y-16">
            {STEPS.map((s, i) => (
              <Reveal as="li" key={s.n} delay={0.05 * i} className="relative pl-12 sm:pl-20" >
                <span data-testid={`process-step-${s.n}`} className="absolute left-0 top-0 grid h-8 w-8 place-items-center rounded-full border border-[#C9A66B] bg-[#1E2228] font-display text-[10px] font-semibold text-[#C9A66B] sm:h-12 sm:w-12 sm:text-xs">{s.n}</span>
                <h3 className="font-display text-xl font-medium uppercase tracking-[0.06em] sm:text-2xl">{s.title}</h3>
                <p className="mt-3 max-w-lg text-base leading-relaxed text-white/75">{s.desc}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
